export default __webpack_public_path__ + "static/streamlining-data-salesforce-47d65ca17a378d16d4dcdecc6f24da2f.png";